module.exports = __webpack_public_path__ + "media/images/hero-deco-mobile-left-742bbc5c1dfc7dba8514e3aac0c051d6.svg";